import { graphql } from '@/gql';
import type { UpdatePartnerMutation, UpdatePartnerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdatePartnerInput = UpdatePartnerMutationVariables;

export type UpdatePartnerOutput = UpdatePartnerMutation['updatePartner'];

export const updatePartner = async ({ codeName, data }: UpdatePartnerInput): Promise<UpdatePartnerOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdatePartner($data: PartnerInputType!, $codeName: String!) {
        updatePartner(data: $data, codeName: $codeName) {
          id
          name
          codeName
          callCenterNumber
          gogoNumber
          extension
          phoneNumber
          email
          streetAddress
          streetAddress2
          city
          state
          country
          zip
          latitude
          longitude
          timeZone
          website
          stripeCustomerId
          subsidyType
          subsidyAmt
          subsidyPot
          subsidyPotStartDate
          subsidyPotEndDate
          membersFlatFee
          maxSubsidyAmt
          credits
          creditsAmtMin
          creditsRenewedAt
          creditsRenewNum
          creditsRenewNumType
          maxRides
          maxRidesRenewedAt
          maxRidesRenewNum
          maxRidesRenewNumType
          subsidyCondition
          rideType
          description
          infoForDriver
          infoForOperator
          isApprovedAddressPartner
          isScheduledRideRestricted
          contactFirstName
          contactLastName
          contactPhoneNumber
          contactEmail
          websiteRegistration
          websiteDashboard
          numberOfRides
          notes
          isDisabled
          isAutoConfirmSurge
          ridePaymentTier
          specialRequestTier
          pharmacyPaymentTier
          gourmetPaymentTier
          groceryPaymentTier
          operatorOrderedRidePrice
          subsidyDescription
          subsidyLocations
          isIncludeInMoveUserIntoPartnershipForm
          isHideRegistrationLink
          isSendRenewalNotification
          turnOnRideOrderingLPAlert
          isRecordAllCalls
          isRollsOverMaxRides
          isNotChargeForCancellationFees
          isNotCountCanceledRides
          isEmailReceipt
          isPartnerWantEmailReceiptToMemberEvenIf100PercentSubsidy
          scheduledRideConfirmedEmail
          scheduledRideReminderDayBeforeEmail
          scheduledRideCancelledSms
          isSendWelcomeKits
          isShowUserPersonalRidesOnPartnerDashboard
          isAutoTip
          tipType
          tipAmount
          tipMinAmount
          tipMaxAmount
          membershipType
          membershipAmount
          maxCallers
          plan
          enrollmentCriteria {
            minAge
            useGeofence
          }
          transactionalSms
          noMail
          marketingMail
          isAlwaysOperator
          abTestOptions
          noCrm
          allowCallersVoipPhoneNumbers
          welcomeMessageUrl
          logoUrl
          collectCc
          isBulkCharge
          isAllowCustomerTip
          subsidyPotRenewedAt
          subsidyPotRenewNum
          subsidyPotRenewNumType
          users {
            id
            firstName
            lastName
            email
            highestRole
            isActive
          }
          newSubsidy
          serviceCode
        }
      }
    `),
    variables: {
      codeName,
      data,
    },
  });

  return response.data!.updatePartner;
};
